export default "https://cdn-static-staging.gokick.com/assets/8a9bc5ae92c259feb7c9591453bfa6ace937db28/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";